import React, { useEffect, useMemo, useState } from "react";
import "./TargetType.css";
import {
  TargetTypeEnum,
  ButtonStateEnum,
  TARGET_TYPES_CONFIG,
  getBaseTargetType,
  getCustomTargetTypeForBase,
  isCustomTargetType,
} from "../../../classes/enums/SppEnum";

const TargetType = ({
  selectedTargetType = TargetTypeEnum.GAP,
  onTargetTypeChange,
  className = "",
  disabledTargetTypes = [],
}) => {
  const [activeTargetType, setActiveTargetType] = useState(selectedTargetType);

  const baseTargetType = useMemo(
    () => getBaseTargetType(activeTargetType),
    [activeTargetType]
  );

  useEffect(() => {
    setActiveTargetType(selectedTargetType);
  }, [selectedTargetType]);

  const handleTargetTypeClick = targetTypeId => {
    if (disabledTargetTypes.includes(targetTypeId)) {
      return;
    }

    const baseForCustom =
      targetTypeId === TargetTypeEnum.GAP ||
      targetTypeId === TargetTypeEnum.SAAS
        ? targetTypeId
        : baseTargetType;

    const resolvedTargetType =
      targetTypeId === TargetTypeEnum.CUSTOM
        ? getCustomTargetTypeForBase(baseForCustom)
        : targetTypeId;

    setActiveTargetType(resolvedTargetType);
    if (onTargetTypeChange) {
      onTargetTypeChange(resolvedTargetType);
    }
  };

  return (
    <div className={`target-type-tab ${className}`}>
      <div className="target-type-tab-wrapper">
        {TARGET_TYPES_CONFIG.map((targetType, index) => {
          const isDisabled = disabledTargetTypes.includes(targetType.id);
          return (
            <button
              key={targetType.id}
              className={`target-type-button ${
                (targetType.isCustom && isCustomTargetType(activeTargetType)) ||
                activeTargetType === targetType.id
                  ? ButtonStateEnum.ACTIVE
                  : ButtonStateEnum.INACTIVE
              } ${isDisabled ? "disabled" : ""}`}
              style={{ "--target-index": index }}
              onClick={() => handleTargetTypeClick(targetType.id)}
              type="button"
              disabled={isDisabled}
            >
              {targetType.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TargetType;
